import { render } from "./ColumnPropertyModal.vue?vue&type=template&id=5a0c2780&scoped=true"
import script from "./ColumnPropertyModal.vue?vue&type=script&lang=js"
export * from "./ColumnPropertyModal.vue?vue&type=script&lang=js"

import "./ColumnPropertyModal.vue?vue&type=style&index=0&id=5a0c2780&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0c2780"]])

export default __exports__